import { useMemo, useState } from "react";
import { Search } from "lucide-react";
import { VehicleRow } from "@/components/VehicleRow";
import { Empty } from "@/components/common";
import { STATUS, vehicleStatus } from "@/lib/fleet";
import { cn } from "@/lib/utils";

const FILTERS = [["all", "Semua"], ["moving", "Bergerak"], ["idle", "Idle"], ["stopped", "Berhenti"], ["offline", "Offline"]];

export function VehicleList({ vehicles, selectedId, onSelect, className }) {
  const [q, setQ] = useState("");
  const [f, setF] = useState("all");
  const counts = useMemo(() => {
    const c = { all: vehicles.length };
    vehicles.forEach((v) => {
      const s = vehicleStatus(v);
      c[s] = (c[s] || 0) + 1;
    });
    return c;
  }, [vehicles]);
  const list = vehicles.filter((v) => {
    const s = q.toLowerCase();
    const okQ = !s || v.name.toLowerCase().includes(s) || v.plate.toLowerCase().includes(s) || (v.imei || "").includes(s);
    return okQ && (f === "all" || vehicleStatus(v) === f);
  });
  return (
    <div className={cn("flex min-h-0 flex-col", className)}>
      <div className="space-y-3 p-3">
        <div className="relative">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari nama, plat, IMEI" className="gt-input pl-9" data-testid="vehicle-list-search" />
        </div>
        <div className="gt-noscroll flex gap-1.5 overflow-x-auto">
          {FILTERS.map(([k, label]) => (
            <button key={k} onClick={() => setF(k)} data-testid={`vehicle-filter-${k}`}
              className={cn("flex shrink-0 items-center gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold transition-colors",
                f === k ? "border-primary bg-primary text-primary-foreground" : "border-border text-muted-foreground hover:text-foreground")}>
              {k !== "all" && <span className="h-1.5 w-1.5 rounded-full" style={{ background: STATUS[k].hex }} />}
              {label} <span className="font-mono opacity-70">{counts[k] || 0}</span>
            </button>
          ))}
        </div>
      </div>
      <div className="gt-scroll min-h-0 flex-1 space-y-1 overflow-y-auto px-2 pb-3" data-testid="vehicle-list">
        {list.map((v) => <VehicleRow key={v.id} v={v} selected={v.id === selectedId} onClick={() => onSelect(v.id)} />)}
        {!list.length && <Empty title="Tidak ada kendaraan" text="Ubah filter atau kata kunci pencarian." />}
      </div>
    </div>
  );
}
